'use strict';
const stripAnsi = require('strip-ansi');
const astralRegex = require('astral-regex');

module.exports = input => stripAnsi(input).replace(astralRegex(), ' ').length;



//////////////////
// WEBPACK FOOTER
// ./node_modules/string-length/index.js
// module id = ./node_modules/string-length/index.js
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13